<script setup lang="ts">
import FeatureFlag from '@frontend/common/feature-flag.vue';
import TodasLasSecciones from '@frontend/secciones/components/todas-las-secciones.vue';
import { usarStoreFeatureFlags } from '@frontend/stores/feature-flags.store';

const featureFlags = usarStoreFeatureFlags();
</script>

<template>
  <feature-flag name="secciones">
    <template #funcionalidadHabilitada>
      <todas-las-secciones v-if="featureFlags.esSuperusuario" />
    </template>
  </feature-flag>
</template>
